import React, { useState, ChangeEvent, useEffect, useContext } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { GeneralContext } from '~/contexts';
import api from '~/services/api';
import './styles.css';

// Components
import { InputLabel } from '~/components/Parts/Forms';

// Images
import logo from '~/assets/images/logo_serena.svg';

// Constants
const initialState = { pass: '', confirm: '' };

const NewPassword: React.FC = () => {
	const [searchParams] = useSearchParams();
	const tokenFromUrl = searchParams.get('token') ?? '';

	const navigate = useNavigate();
	const { logged } = useContext(GeneralContext);
	const [values, setValues] = useState(initialState);
	const [message, setMessage] = useState<string>('');
	const [errors, setErrors] = useState<String[]>([]);

	function onChange(event: ChangeEvent<HTMLInputElement>) {
		const { name, value } = event.target;
		setValues({ ...values, [name]: value });
	}

	function onSubmit(event: React.FormEvent<HTMLFormElement>) {
		event.preventDefault();

		if (!tokenFromUrl) {
			setErrors(['Link inválido ou incompleto. Solicite um novo e-mail de recuperação.']);
			return;
		}

		const errArr: string[] = [];
		if (values.pass === '' || values.confirm === '') {
			if (values.pass === '') errArr.push('O campo de senha está vazio');
			if (values.confirm === '') errArr.push('O campo de confirmação está vazio');
			setErrors(errArr);
			return;
		}
		if (values.pass !== values.confirm) {
			errArr.push('A senha e a confirmação estão diferentes');
			setErrors(errArr);
			return;
		}

		api
			.post('remember-password', { token: tokenFromUrl, pass: values.pass })
			.then((resp: any) => {
				setErrors([]);
				setValues(initialState);
				setMessage(resp.data.message);
			})
			.catch((err: any) => {
				setMessage('');
				const status = err.response?.status;
				if (status === 400) {
					const error = err.response.data?.errors;
					setErrors(Array.isArray(error) ? error : [String(error ?? 'Token inválido ou expirado.')]);
				} else {
					setErrors(['Não foi possível atualizar a senha. Tente novamente mais tarde.']);
				}
			});
	}

	function treatErrors() {
        return (
            <div className="boxErrors">
				{ errors.map(el => <span key={`error_${el}`}>{ el }</span>) }
            </div>
        )
    }

    function treatMessage() {
        return (
            <div className="boxMessage">
				{ message }
            </div>
        )
    }

	useEffect(() => {
		if (logged) navigate('/');
	}, [logged, navigate]);

	const missingToken = !tokenFromUrl;

	return (
		<div id="newPass">
			<div className="header">
				<img src={logo} alt="Logo Serena" />

				<h2>Redefinir senha</h2>
			</div>

			{missingToken && (
				<>
					<div className="boxErrors">
						<span>
							Este link não contém um token válido. Abra o link enviado por e-mail ou solicite uma nova
							recuperação de senha.
						</span>
					</div>
					<div className="back" style={{ marginTop: 24 }}>
						<Link to="/login" className="dec">
							Voltar ao login
						</Link>
						{' · '}
						<Link to="/lembrar-senha" className="dec">
							Esqueci minha senha
						</Link>
					</div>
				</>
			)}

			{!missingToken && (
				<>
					{Array.isArray(errors) && errors.length > 0 && treatErrors()}
					{!errors.length && message && treatMessage()}

					<form onSubmit={onSubmit} autoComplete="off" method="POST">
						<InputLabel name="pass" type="password" labelName="Nova senha" value={values.pass} onChange={onChange} />
						<InputLabel
							name="confirm"
							type="password"
							labelName="Confirmação de senha"
							value={values.confirm}
							onChange={onChange}
							style={{ marginTop: '20px' }}
						/>

						<button className="send" type="submit">
							Salvar senha
						</button>

						<div className="back">
							<span>Precisa de um novo link?</span>
							<Link to="/lembrar-senha" className="dec">
								Esqueci minha senha
							</Link>
							{' · '}
							<Link to="/login" className="dec">
								Voltar ao login
							</Link>
						</div>
					</form>
				</>
			)}
		</div>
	);
};
export default NewPassword;
